import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import NetworkSelector from './networkSelector.js';
import Loader from './loader.js';
import debounce from 'lodash/debounce';

import './css/appsCreator.css';

export default class AppCreator extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      step: 1,
      loadingApp: false,
      newApp: {
        name: '',
        framework: 'android',
        packageState: 'has-error',
        nameState: 'has-error',
        coppa: false,
        is_game: '0',
        gps_enabled: '1',
        package: ''
      },
      steps: [
        "Configure App",
        "Select Ad Types",
        "Select Ad Networks"
      ]     
    };
  }

  componentWillMount() {
    this.debouncedGetAppName = debounce(() => {
      this.getAppName.apply(this, [this.state.newApp.package]);
    }, 1500);
  }

  getAppName(packageName){

    this.setState({
      loadingApp: true
    });
    
    fetch(`/app_details.php?package=${packageName}`,{
      credentials: "same-origin"
    }).then(rsp => rsp.json())
      .then(json => {
        this.setState(prevState => {
          let newApp = prevState.newApp;
          newApp.name = json.name;
          newApp.icon = json.icon;
          newApp.packageState = 'has-success';
          newApp.nameState = 'has-success';
          newApp.is_game = json.isGame;

          return {
            newApp: newApp,
            loadingApp: false
          };
        });
      }).catch( _ => {
        this.setState(prevState => {
          let newApp = prevState.newApp;
          newApp.packageState = 'has-warning';

          this.notify({
            type: 'warning',
            msg: 'Package is invalid, Enter data manually'
          });
          
          return {
            newApp: newApp,
            loadingApp: false
          };
        });
        
      });

  }
  
  setFramework(name){
    this.setState(prevState => {
      let newApp = prevState.newApp;
      newApp.framework = name;
      return {
        newApp: newApp
      };
    });
  }

  setCoppa(event) {
    let coppa = event.target.checked;
    this.setState(prevState => {
      let newApp = prevState.newApp;

      newApp.coppa = coppa;

      return {
        newApp: newApp
      };
    });
  }

  setGps(event) {
    let value = event.target.value;
    this.setState(prevState => {
      let newApp = prevState.newApp;

      newApp.gps_enabled = value;

      return {
        newApp: newApp
      };
    });
  }

  
  setPackageName(event) {
    let newName = event.target.value;
    
    this.setState(prevState => {

      let newApp = prevState.newApp;

      newApp.package = newName;
      newApp.packageState = (newName !== "") ?
        'has-warning' : 'has-error';

      return {
        newApp: newApp
      };
    });
    this.debouncedGetAppName();
  }

  setAppName(event) {
    let newName = event.target.value;
    
    this.setState(prevState => {

      let newApp = prevState.newApp;

      newApp.name = newName;
      newApp.nameState = (newName !== "") ?
        'has-success' : 'has-error';

      return {
        newApp: newApp
      };
    });
  }

  
  notify(msg){
    if (this.props.notifyHandler){
      this.props.notifyHandler(msg);
    }
  }
  
  stepForward(){

    if (this.state.step == 1){

      let foundError = false;
      
      if (this.state.newApp.packageState == 'has-error'){
        this.notify({
          type: 'error',
          msg: 'Package is invalid'
        });

        foundError = true;
      }

      if (this.state.newApp.nameState == 'has-error'){
        this.notify({
          type: 'error',
          msg: 'Name is invalid'
        });

        foundError = true;
      }

      if (foundError){
        return;
      }
    }

    if (this.state.step == 2){      
    }

    // all ok
    this.setState(prevState => {
      ++prevState.step;
      return prevState;
    });
  }

  stepBackwards(){
    this.setState(prevState => {
      --prevState.step;
      return prevState;
    });
  }

  done(){


    this.notify({
      type: 'warning',
      msg: `Adding ${this.state.newApp.name}...`
    });
        
    let networks = this.networkSelector.networks;

    let framework;

    switch(this.state.newApp.framework){
    case 'android':
      framework = 'NATIVE';
      break;
    case 'unity':
      framework = 'UNITY';
      break;      
    case 'air':
      framework = 'AIR';
    }
    
    if (this.props.newAppHandler){
      this.props.newAppHandler({
        name: this.state.newApp.name,
        package: this.state.newApp.package,
        is_game: this.state.newApp.is_game,
        framework: framework,
        coppa: this.state.newApp.coppa,
        gps_enabled: this.state.newApp.gps_enabled,
        networks: networks,
        floorPrices: []
      });
    }

    this.setState({
      done: true
    });
  }

  
  render() {

    if (this.state.done){
      return <Loader/>;
    }

    let stepContent = <div/>;

    switch(this.state.step){
    case 1:
      stepContent = (
        <form>
          <label>Choose Framework:</label>

          <div id="frameworks">
            <div className=
                 {"select-item " +
                   (this.state.newApp.framework == 'android' ?
                 'selected' : '')}
                 onClick={_=> this.setFramework('android')}>
              <img src="/assets/img/frameworks/android.jpg"/>
              <span>Android Native</span>
              <i className="fa fa-check-circle selected"/>
              <i className="fa fa-times-circle"/>
            </div>
            <div className=
                 {"select-item " +
                   (this.state.newApp.framework == 'unity' ?
                 'selected' : '')}
                 onClick={ _=> this.setFramework('unity')} >
              <img src="/assets/img/frameworks/unity.png"/>
              <span>Unity</span>
              <i className="fa fa-check-circle selected"/>
              <i className="fa fa-times-circle"/>
            </div>
            <div className=
                 {"select-item " +
                   (this.state.newApp.framework == 'air' ?
                 'selected' : '')}
                 onClick={_=> this.setFramework('air')}>
              <img src="/assets/img/frameworks/air.png"/>
              <span>Adobe Air</span>
              <i className="fa fa-check-circle selected"/>
              <i className="fa fa-times-circle"/>
            </div>
            <div className="clearfix"/>
          </div>

          <div className=
               {"form-group "+this.state.newApp.packageState}>
            <label className="control-label">
              Package Name
              <i className="fa fa-asterisk"></i>
            </label>
            <input value={this.state.newApp.package}
                   onChange={this.setPackageName.bind(this)}
                   disabled={this.state.loadingApp}
                   type="text"
                   className="form-control input-lg"
                   placeholder="Package Name"/>
          </div>

          { this.state.loadingApp && <Loader/> }
          { this.state.newApp.icon &&
          <img height="30" src={this.state.newApp.icon}/> }
          
          <div className=
               {"form-group "+this.state.newApp.nameState}>
            <label className="control-label">
              App Name
            </label>
            <input value={this.state.newApp.name}
                   onChange={this.setAppName.bind(this)}                   
                   type="text"
                   className="form-control input-lg"
                   name="name" placeholder="App Name"/>
          </div>                   

          <div className="form-group">
            <label className="control-label">
              Is It A Game?
            </label>
            <select
              className="form-control input-lg"
              value={this.state.newApp.is_game}
              >
              <option value="1">Yes</option>
              <option value="0">No</option>              
            </select>
          </div>

          <div className="form-group">
            <label className="control-label">
              Allow Google ADX Ads to use GPS data when activated by user? (improves CPM)
            </label>
            <select className="form-control input-lg"
                    value={this.state.newApp.gps_enabled}
                    onChange={this.setGps.bind(this)}>
              <option value="1">Yes</option>
              <option value="0">No</option>              
            </select>
          </div>


          <div className="form-group">
            <label className="control-label">
              Coppa Compliance
            </label>

            <div>
              <input id="coppa"
                     type="checkbox"
                     checked={this.state.newApp.coppa}
                     onChange={this.setCoppa.bind(this)}/>
              Is this app is directed to children under the age of 13?
            </div>
          </div>          

          
        </form>                  
      );
      break;

    case 2:
      stepContent = (
        <div>
          <div className="select-item selected"
               onClick={_ => {
                 this.notify({
                   type: 'error',
                   msg: 'Only Interstitial avalible in current version'
                 });
            }}>
            <img src="/assets/img/mobile.png"/>
            <span>Interstitial</span>
            <i className="fa fa-check-circle selected"/>
            <i className="fa fa-times-circle"/>     
          </div>

          <div className="select-item"
               onClick={_ => {
                 this.notify({
                   type: 'error',
                   msg: 'Only Interstitial avalible in current version'
                 });
            }}>
            <img src="/assets/img/mobile.png"/>
            <span>Banner</span>
            <i className="fa fa-check-circle selected"/>
            <i className="fa fa-times-circle"/>     
          </div>

          <div className="select-item"
               onClick={_ => {
                 this.notify({
                   type: 'error',
                   msg: 'Only Interstitial avalible in current version'
                 });
            }}>
            <img src="/assets/img/mobile.png"/>
            <span>Reward Video</span>
            <i className="fa fa-check-circle selected"/>
            <i className="fa fa-times-circle"/>     
          </div>

          <div className="select-item">
            <img src="/assets/img/mobile.png"/>
            <span>Non-Skippable Video</span>
            <i className="fa fa-check-circle selected"/>
            <i className="fa fa-times-circle"/>     
          </div>
          
          <div className="clearfix"/>
        </div>
      );
      break;
      
    case 3:
      stepContent = <NetworkSelector
      ref={ x => this.networkSelector = x}
      isGame={this.state.newApp.is_game}
      notifyHandler={this.props.notifyHandler}/>;
      break;
    case 3:
      
    }
    
    return (
      <div className="row">        
        <div className="col-md-6 col-md-offset-3">
          <div id="addModal">
            <h3>Add New App</h3>
            <h4><span className="label label-danger">
                Step {this.state.step}:
              </span><small>
                {"  "+this.state.steps[this.state.step-1]}
            </small></h4>
            {stepContent}
            <hr></hr>
            <div id="appModal-buttons">
              <div className="pull-left">
                <button disabled={this.state.step === 1}
                        onClick={_ => this.stepBackwards()}
                  className="btn btn-primary">
                  <i className="fa fa-arrow-circle-left" ></i>Previous</button>
              </div>
              <div className="pull-right">
                { this.state.step == this.state.steps.length ? (
                  <button onClick={_ => this.done()}
                    className="btn btn-success">
                    <i className="fa fa-check-circle" ></i>
                    Add App</button>
                ) :
                  (
                    <button onClick={_ => this.stepForward()}
                      className="btn btn-primary">
                      <i className="fa fa-arrow-circle-right">
                      </i>
                      Next
                    </button>)}</div>        
        </div>
        <div className="clearfix"/>
        </div>
        </div>
        </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/appsCreator.js